import { useCallback, useEffect, useState } from 'react';
import { loadColumnPrefs, saveColumnPrefs } from '@/lib/tableColumnPrefs';

function readUserId() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')?.id || 'anon';
  } catch {
    return 'anon';
  }
}

/**
 * Spaltenwahl mit Persistenz pro User + viewKey (localStorage).
 * @param {string} viewKey z. B. 'uv-uebersicht', 'students-list'
 * @param {Array<{key:string,label:string,visible?:boolean}>} defaultColumns
 */
export default function useTableColumns(viewKey, defaultColumns) {
  const [userId, setUserId] = useState(readUserId);
  const [columns, setColumnsState] = useState(() => loadColumnPrefs(viewKey, defaultColumns, readUserId()));

  useEffect(() => {
    const sync = () => {
      const nextId = readUserId();
      setUserId(nextId);
      setColumnsState(loadColumnPrefs(viewKey, defaultColumns, nextId));
    };
    sync();
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
    // defaultColumns is a module-level constant
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewKey]);

  const setColumns = useCallback((nextOrUpdater) => {
    setColumnsState((prev) => {
      const next = typeof nextOrUpdater === 'function' ? nextOrUpdater(prev) : nextOrUpdater;
      saveColumnPrefs(viewKey, next, userId);
      return next;
    });
  }, [viewKey, userId]);

  const isVisible = useCallback(
    (key) => columns.find((c) => c.key === key)?.visible !== false,
    [columns],
  );

  return { columns, setColumns, isVisible };
}
